export default __webpack_public_path__ + "static/diceIcon-cafb25225153e244ec3df16d85e923b9.svg";